export const userSessionCookie = 'cv_user'
export const fbLoginCookie = 'playment.fbLogin'
export const cvRefreshTokenCookieName = 'rt_sync'
export const cvPlaymentDomain = '.playment.io'
export const tiaiDomain = '.telusinternational.ai'
